import { useInfiniteQuery } from "@tanstack/react-query";
import { searchDiamonds } from "../api/diamonds";

export default function useDiamondsInfiniteQuery(filters) {
    return useInfiniteQuery({
        queryKey: ["wahchan", "diamonds", filters],
        queryFn: ({ pageParam = 1, signal }) =>
            searchDiamonds({ ...filters, page: pageParam }, { signal }),
        initialPageParam: 1,
        // Stop when server returns empty page OR a short page (partial last).
        // Uses first page's length as the effective page size.
        getNextPageParam: (lastPage, allPages) => {
            if (!lastPage || lastPage.length === 0) return undefined;
            const firstPageSize = allPages[0]?.length ?? 0;
            if (firstPageSize > 0 && lastPage.length < firstPageSize) {
                return undefined;
            }
            return allPages.length + 1;
        },
        enabled: !!filters,
        staleTime: 30_000,
        refetchOnWindowFocus: false,
    });
}
